<template>
  <layout-basic>
    <v-container fluid>
      <v-row>
        <v-col md="12">
          <v-text-field placeholder="Search" prepend-icon="fa-search"></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col md="12">
          <v-card flat>
            <v-data-table
              :headers="headers"
              :options.sync="options"
              :server-items-length="serverItemsLength"
              :loading="loading"
              :items="courses"
            >
              <template v-slot:item.name="{ item }">
                <img :src="transfrom(item.thumbnail.data.key)" class="course-name" />
                <span>{{item.name}}</span>
              </template>
              <template v-slot:item.completion_progress="{ item }">
                <v-progress-linear height="20" color="blue" :value="item.completion_progress"></v-progress-linear>
              </template>
            </v-data-table>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </layout-basic>
</template>
<script>
import { IMPROVE_CONFIG } from "@/config.js";
import { EventBus } from "@/event-bus.js";
import courseAPI from "@/api/course.js";
import thumbSizes from "@/utils/thumbs.js";
import LayoutBasic from "@/layouts/Dashboard";
export default {
  name: "CoursesAdmin",
  components: {
    LayoutBasic
  },
  data() {
    return {
      headers: [
        { text: "Course", value: "name" },
        {
          text: "Users",
          value: "total_enrolled_individual_users",
          sortable: false
        },
        { text: "Groups", value: "total_groups", sortable: false },
        { text: "Total Users", value: "total_users", sortable: false },
        { text: "In Progress", value: "total_inprogress", sortable: false },
        { text: "Completed", value: "total_completed", sortable: false },
        { text: "Not Started", value: "total_not_started", sortable: false },
        {
          text: "Completion Progress",
          value: "completion_progress",
          sortable: false
        },
        { text: "", value: "id", sortable: false, align: "end" }
      ],
      courses: [],
      pagination: {},
      options: {},
      loading: false,
      coursesInstalling: false
    };
  },
  computed: {
    serverItemsLength: function() {
      return this.pagination.total;
    },
    itemsPerPage: function() {
      return this.pagination.per_page;
    },
    page: function() {
      return this.pagination.current_page;
    },
    params: function() {
      return this.$gf.getQueryString(this.options, this.serverItemsLength);
    }
  },
  watch: {
    options: {
      handler() {
        this.getCourses();
      },
      deep: true
    }
  },
  mounted() {
    this.setEventBus();
  },
  methods: {
    deleteCourse() {},
    getCourses() {
      this.loading = true;
      courseAPI.getCourses(this.params + "&include=thumbnail").then(resp => {
        this.courses = resp.data.data;
        this.pagination = resp.data.meta.pagination;
        this.loading = false;
      });
    },
    installCourses() {
      this.coursesInstalling = true;
      courseAPI.installCourses().then(() => {
        this.coursesInstalling = false;
      });
    },
    transfrom(key) {
      const imageRequest = JSON.stringify({
        bucket: `${IMPROVE_CONFIG.BUCKET}`,
        key: key,
        edits: thumbSizes.small
      });
      return `${IMPROVE_CONFIG.SERVERLESS_IMAGE_HANDLER}/${btoa(imageRequest)}`;
    },
    setEventBus() {
      EventBus.$on("COURSES_UPDATED", payload => {
        this.params = payload;
        this.getCourses();
      });
    }
  }
};
</script>
<style scoped>
.course-name {
  vertical-align: middle;
  padding-right: 10px;
}
</style>